
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '@/lib/utils';

interface ClickPointsAnimationProps {
  points: number;
  x: number;
  y: number;
  type: 'like' | 'post';
  show: boolean;
  onAnimationComplete?: () => void;
}

const getAnimationColor = (type: 'like' | 'post') => {
  return type === 'like' ? 'text-yellow-500' : 'text-primary';
};

const ClickPointsAnimation = ({ 
  points, 
  x, 
  y, 
  type,
  show,
  onAnimationComplete 
}: ClickPointsAnimationProps) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 1, y: 0 }}
          animate={{ 
            opacity: [0, 1, 1, 0],
            scale: [1, 1.1, 1, 1],
            y: [0, -40]
          }}
          exit={{ opacity: 0 }}
          transition={{ 
            duration: 1.2,
            times: [0, 0.15, 0.7, 1],
            ease: "easeOut"
          }}
          onAnimationComplete={onAnimationComplete}
          className="fixed pointer-events-none z-50 select-none"
          style={{ 
            left: x - 20,
            top: y - 20
          }}
        >
          <div 
            className={cn(
              "flex items-center gap-2 font-bold",
              getAnimationColor(type),
              "drop-shadow-[0_0_15px_rgba(255,215,0,0.7)]"
            )}
          >
            <span className="text-2xl">👑</span>
            <span className={cn(
              "text-2xl font-extrabold",
              type === 'like' && "text-yellow-400"
            )}>
              +{points}
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ClickPointsAnimation;
